import clsx from "clsx";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { COVEO_IGNORE_CLASS } from "../../utils/coveoConst";
import styles from "./C245_AnimatedNumbers.module.scss";

export interface AnimatedNumberData {
  odoNumber: string;
  prefix: string;
  suffix: string;
  odoNumberStyle: string;
  heading: string;
  description: string;
}

export interface AnimatedNumbersData {
  animatedNumbers: Array<{
    metadata: { tags: string[] };

    // fields: AnimatedNumberData;
    odoNumber: string;
    prefix: string;
    suffix: string;
    odoNumberStyle: string;
    heading: string;
    description: string;
  }>;
}
interface AnimatedNumberProps extends AnimatedNumberData {
  isVisible: boolean;
}

export const AnimatedNumber = (props: AnimatedNumberProps) => {
  const {
    odoNumber,
    prefix,
    suffix,
    odoNumberStyle,
    heading,
    description,
    isVisible,
  } = props;
  const numberRef = useRef<HTMLSpanElement>(null);
  const hiddenRef = useRef<HTMLSpanElement>(null);
  const [hiddenWidth, setHiddenWidth] = useState(0);

  const format = (number) => {
    return Math.round(number)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const finalNumberText =
    `${prefix ?? ""}${odoNumber ?? ""}${suffix ?? ""}`.trim();
  const srText = heading ? `${finalNumberText} ${heading}` : finalNumberText;

  useEffect(() => {
    let interval;

    if (isVisible) {
      const value = parseInt(odoNumber.replace(/,/g, ""));
      const perTick = value / 200;
      let currentValue = 0;

      const update = () => {
        if (currentValue < value) {
          currentValue = Math.round((currentValue + perTick) * 1e12) / 1e12;
          if (numberRef?.current) {
            numberRef.current.textContent = format(currentValue);
          }
          requestAnimationFrame(update);
        } else {
          if (numberRef?.current) {
            numberRef.current.textContent = format(value);
          }
        }
      };

      update();
    }

    return () => clearInterval(interval);
  }, [isVisible, odoNumber]);

  useLayoutEffect(() => {
    setHiddenWidth(hiddenRef?.current?.getBoundingClientRect().width);
  }, []);

  return (
    <div className={clsx(styles.item, COVEO_IGNORE_CLASS, odoNumberStyle)}>
      <span className={styles.hidden}>{srText}</span>
      <div
        className={clsx(styles.number, "highlight", "flex flex-nowrap gap-4")}
        aria-hidden="true"
      >
        {prefix}
        <div className="relative">
          <span
            ref={numberRef}
            style={{ minWidth: hiddenWidth }}
            className={styles.odo}
          >
            0
          </span>
          <span
            ref={hiddenRef}
            className={clsx(styles.odo, "absolute left-0 opacity-0")}
          >
            {format(odoNumber)}
          </span>
        </div>
        {suffix}
      </div>
      {heading && (
        <p className={styles.heading} aria-hidden="true">
          {heading}
        </p>
      )}
      {description && <p>{description}</p>}
    </div>
  );
};

export default AnimatedNumber;
